<template>
  <div class="dal-slider-audio">
    <button
      @click="toggle"
      class="button"
    >
      <svg
        class="svg"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          class="circle-foreground"
          :class="{
            'active': progress > 0
          }"
          v-bind:style="{
            'stroke-dasharray': `${progress}px 125px`
          }"
        />
      </svg>
      <AudioPauseIcon
        v-if="!paused"
        class="pause"
      ></AudioPauseIcon>
      <AudioIcon v-else></AudioIcon>
    </button>
    <audio
      class="audio"
      :src="src"
      ref="audio"
      @play="trackAudio"
      @playing="onPlay"
      @pause="onPause"
      @ended="onEnd"
      @timeupdate="onTimeupdate"
    ></audio>
  </div>
</template>

<script>
import { EventBus } from '@/EventBus'
import { AudioIcon, AudioPauseIcon } from '@/components/icons'
import { trackAudio } from '@/utils/track'

export default {
  name: 'DalSliderAudio',
  props: {
    src: {
      type: String,
      required: true
    },
    trackTitle: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      paused: true,
      tracked: false,
      progress: 0,
      startOfAudio: true,
      seen: false
    }
  },
  components: {
    AudioIcon,
    AudioPauseIcon
  },
  methods: {
    toggle () {
      if (this.paused) {
        this.$refs.audio.play()
      } else {
        this.$refs.audio.pause()
      }
    },
    onPlay () {
      this.startOfAudio = false
      EventBus.$emit('pauseAll', this.$el)
      this.paused = this.$refs.audio.paused

      EventBus.$on('pauseAll', el => {
        if (el !== this.$el) {
          this.$refs.audio.pause()
        }
      })
    },
    onPause () {
      this.paused = this.$refs.audio.paused
    },
    onEnd () {
      this.startOfAudio = true
      this.paused = true
      this.progress = 0
    },
    trackAudio () {
      if (!this.tracked) {
        trackAudio(this.track, this.trackTitle)
      }
      this.tracked = true
    },
    onTimeupdate () {
      const percentagePlayed = (this.$refs.audio.currentTime / this.$refs.audio.duration) * 100
      this.progress = Math.ceil(percentagePlayed * 1.25)
    }
  },
  computed: {
    titleClasses () {
      return {
        'is-active': !this.paused
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dal-slider-audio {
  position: absolute;
  bottom: -20px;
  left: 0;
  right: 0;
  margin: 0 auto;
  text-align: center;
}
.svg {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  overflow: visible;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.circle-foreground {
  stroke: white;
  stroke-dasharray: 0px 125px;
  stroke-dashoffset: 0px;
  stroke-linecap: round;
  -webkit-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: rotate(-90deg);
  transform: rotate(-90deg);
  r: 20px;
  cx: 50%;
  cy: 50%;
  fill: transparent;
  stroke-width: 0px;
  transition: all 300ms ease;
}
.pause {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  margin: 0 auto;
}
.active {
  stroke-width: 2px;
}
.button {
  position: relative;
  height: 40px;
  width: 40px;
  background-color: $c-red;
  border-radius: 50%;
  outline: 0;
  cursor: pointer;
  border: none;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  display: inline-block;
  padding: 0;
  vertical-align: top;
}
.audio-enter-active, .audio-leave-active {
  transition: all .5s cubic-bezier(.19,1,.22,1);
  transition-property: opacity, transform;
  will-change: opacity, transform;
}
.audio-enter, .audio-leave-to {
  opacity: 0;
  transform: translate(75px, -75px) scale(0.6);

  .title {
    opacity: 0;
    transform: translateX(-25px)
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dal/DalSliderAudio.vue